// ==============================|| OVERRIDES - TABLE PAGINATION ||============================== //

export default function TablePagination(theme) {
	return {
		MuiTablePagination: {
			styleOverrides: {}
		}
	}
}
